import { useState } from "react";
import JoinClassroomModal from "../Modals/JoinClassroomModal";

const JoinClassHook = () => {
  const classCode = new URLSearchParams(window.location.search).get("joinClass") || "";
  const [open, setOpen] = useState(classCode !== "");
  return <JoinClassroomModal classCode={classCode} closeModal={() => setOpen(false)} open={open} />;
};

export { JoinClassHook };
